var map = {
	"@profile/profile.module.ngfactory": [
		"./src/app/profile/profile.module.ngfactory.js",
		"profile-profile-module-ngfactory"
	],
	"@reports/reports.module.ngfactory": [
		"./src/app/reports/reports.module.ngfactory.js",
		"reports-reports-module-ngfactory"
	],
	"@results/results.module.ngfactory": [
		"./src/app/results/results.module.ngfactory.js",
		"results-results-module-ngfactory"
	],
	"@student/student.module.ngfactory": [
		"./src/app/student/student.module.ngfactory.js",
		"student-student-module-ngfactory"
	],
	"@teacher/teacher.module.ngfactory": [
		"./src/app/teacher/teacher.module.ngfactory.js",
		"teacher-teacher-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;